/* eslint @typescript-eslint/no-var-requires: "off" */

import apiClient from '../../config/apiClient';
import { deleteAccessToken, setAccessToken, setToken, getAccessToken } from '../../helper/tokenHelper';
import { configApp } from '../../config/config';

import { AuthInterface, SocialLoginAuth } from '../../interface/auth.interface';
import { TypeChangePassword } from '../../interface/change.interface';

const qs = require('querystringify');

export const getUsers = async () => {
	return await apiClient.get(`/auth/users`);
};

export const getMeal = async () => {
	return await apiClient.get(`/meals/get`);
};

export const getUser = async () => {
	// console.log(apiClient);
	return await apiClient.get(`/auth/user`);
};

export const getUserInfor = async () => {
	return await apiClient.get(`/auth/user`);
};

export const getChat = async () => {
	return await apiClient.get(`/auth/get_chat`);
};

export const addMeals = async (paramsCreate: any) => {
	return await apiClient.post(`/meals/addOrUpdate`, paramsCreate);
};

export const updateMeals = async (paramsEdit: any, checkNumberMeals: any) => {
	// console.log(`/meals/addOrUpdate?id=${checkNumberMeals}`);
	return await apiClient.post(`/meals/addOrUpdate?id=${checkNumberMeals}`, paramsEdit);
};

export const getMeals = async () => {
	return await apiClient.get(`/meals/get`);
};

export const loginUser = async (params: AuthInterface) => {
	return await apiClient.post('/auth/login', params);
};

export const getMealsByID = async (params: any) => {
	return await apiClient.get(`/meals/getById?id=${params}`);
};

export const addOrUpdateDish = async (params: any) => {
	// console.log(params);
	return await apiClient.post('/dishes/addOrUpdate', params);
};

export const getStatistic = async (params: any) => {
	const objParamUrls = qs.stringify(params);
	// console.log(`/statistic/get?${objParamUrls}`);
	return await apiClient.get(`/statistic/get?${objParamUrls}`);
};

export const getStatisticSettle = async () => {
	return await apiClient.get(`/statistic/settlement`);
};

export const settlementDebtorByOwner = async (params : any) => {
	const objParamUrls = qs.stringify(params);
	// console.log(`/statistic/settlementdebtorbyowner?${objParamUrls}`);
	return await apiClient.get(`/statistic/settlementdebtorbyowner?${objParamUrls}`);
};

export const checkmealisdone = async (params : any) => {
	const objParamUrls = qs.stringify(params);
	// console.log(`/statistic/checkmealisdone?${objParamUrls}`);
	return await apiClient.get(`/statistic/checkmealisdone?${objParamUrls}`);
};

export const settlementMeal = async (params: any) => {
	const objParamUrls = qs.stringify(params);
	return await apiClient.get(`/statistic/settlementMeal?${objParamUrls}`);
};

export const getStatisticSettleInDay = async (params: any) => {
	// console.log("params", params);
	const objParamUrls = qs.stringify(params);
	// console.log(`/statistic/get?${objParamUrls}`);
	return await apiClient.get(`/statistic/settlementinday?${objParamUrls}`);
};

export const logoutUser = async (params: any) => {
	return await apiClient.post('/logout', params);
};

export const updatePassword = async (params: TypeChangePassword) => {
	return await apiClient.post('/update-password', params);
};

export const registerUser = async (params: any) => {
	return await apiClient.post('/register', params);
};

export const resetPasswordUser = async (params: any) => {
	// console.log(params);
	return await apiClient.post('/send-email-forgot-pass', params);
};

export const socialLoginUser = async (params: SocialLoginAuth) => {
	return await apiClient.post('/login-social', params);
};
